const S = ({ id, title, children }) => (
  <section id={id} className="mt-8">
    <h2 className="text-lg font-semibold text-slate-900">{title}</h2>
    <div className="mt-2 space-y-2 text-sm leading-relaxed text-slate-700">{children}</div>
  </section>
);

export default function Privacy() {
  return (
    <div data-testid="privacy-page" className="min-h-screen bg-white px-5 py-12">
      <article className="mx-auto max-w-3xl">
        <h1 className="text-3xl font-bold tracking-tight text-slate-900">Política de Privacidade</h1>
        <p className="mt-2 text-sm text-slate-500">Unica · última atualização: 15/10/2026</p>
        <S title="1. Quem somos">
          <p>Esta política explica como a Unica ("nós") trata os dados pessoais dos seus clientes assinantes ao enviar avisos de vencimento, cobranças e atendimento por WhatsApp, SMS e e-mail.</p>
        </S>
        <S title="2. Dados que tratamos">
          <p>Nome, número de telefone/WhatsApp, e-mail, usuário da assinatura, plano, valor, data de vencimento, status de pagamento e o conteúdo das mensagens trocadas conosco. Não solicitamos dados sensíveis.</p>
        </S>
        <S title="3. Para que usamos">
          <p>Exclusivamente para gerir a sua assinatura: lembrar o vencimento, enviar o link de pagamento, confirmar renovações e responder às suas mensagens. Não vendemos nem cedemos seus dados para publicidade de terceiros.</p>
        </S>
        <S title="4. Base legal (LGPD)">
          <p>Execução do contrato de assinatura (art. 7º, V, da Lei 13.709/2018) e legítimo interesse na cobrança de valores devidos (art. 7º, IX).</p>
        </S>
        <S title="5. Com quem compartilhamos">
          <p>Somente com os operadores necessários para o envio das mensagens e pagamentos: Meta (WhatsApp Business Platform), provedor de SMS, provedor de e-mail e o processador de pagamento do link enviado. Cada um trata os dados apenas para prestar esse serviço.</p>
        </S>
        <S title="6. Por quanto tempo guardamos">
          <p>Enquanto a assinatura estiver ativa e, depois, pelo prazo necessário para cumprir obrigações legais ou resolver pendências de pagamento.</p>
        </S>
        <S title="7. Segurança">
          <p>Os dados ficam em servidores com acesso restrito e as credenciais de integração são armazenadas de forma protegida. Senhas de acesso nunca são enviadas por WhatsApp, SMS ou e-mail.</p>
        </S>
        <S id="exclusao-de-dados" title="8. Seus direitos e exclusão de dados">
          <p>Você pode pedir acesso, correção ou exclusão dos seus dados, ou deixar de receber mensagens, a qualquer momento: responda <b>"SAIR"</b> no WhatsApp ou envie um e-mail para <a className="text-sky-700 underline" href="mailto:contato@omegadash.online">contato@omegadash.online</a> informando o seu número. Atendemos em até 15 dias.</p>
        </S>
        <S title="9. Contato">
          <p>Unica · <a className="text-sky-700 underline" href="mailto:contato@omegadash.online">contato@omegadash.online</a></p>
        </S>
      </article>
    </div>
  );
}
